import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from 'src/app/core/api/api.service';
import { METERS_ENDPOINTS } from 'src/app/core/api/endpoints/meters.endpoints';

@Injectable({
  providedIn: 'root',
})
export class MetersService {
  private api = inject(ApiService);

  /**
   *  implement getOrderMeters method
   */
  getOrderMeters(orderID): Observable<any> {
    return this.api.get<any>(METERS_ENDPOINTS.V1.ADMIN_METERS(orderID)).pipe(
      map((data: any) => {
        return data;
      })
    );
  }

  deleteMeter(meterID): Observable<any> {
    return this.api
      .delete(METERS_ENDPOINTS.V1.ADMIN_DEL_METER(meterID))
      .pipe(
        map((data: any) => {
          return data;
        })
      );
  }

  updateMeter(orderID, meter): Observable<any> {
    return this.api
      .put<any>(METERS_ENDPOINTS.V1.ADMIN_METERS(orderID), meter)
      .pipe(
        map((data: any) => {
          return data;
        })
      );
  }

  addMeter(orderID, data): Observable<any> {
    return this.api
      .post<any>(METERS_ENDPOINTS.V1.ADMIN_METER(orderID), data)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }
}
